export default class Claim {
  public OrderId!: number;
  public TrackingNumber!: number;
  public IsSender!: null | boolean;
  public Recipient!: string;
  public FirstName!: string;
  public LastName!: string;
  public Email!: string;
  public Phone!: string;
  public Reason!: string;
  public Description?: string;
  public ContentDescription?: string;
  public DamageOrLoss!: string;
  public BillOfSalePics?: any[];
  public PackingPics?: any[];
  public EstimatePics?: any[];
  public OutsidePics?: any[];
  public InsidePics?: any[];

  public constructor(init?: Partial<Claim>) {
    Object.assign(this, init);
    this.Email = "";
    this.Phone = "";
    this.DamageOrLoss = "loss";
    this.IsSender = null;
  }
}
